// extracted by mini-css-extract-plugin
module.exports = {"slidein":"slidein--2E3EO4","closeslide":"closeslide--3ijE4d","active":"active--1yvz94"};